import React, { Component } from 'react';
import { Background } from '../COMPONENTS/Background';
import { connect } from 'react-redux';
import '../styles.css';
import { OPTIONS_KEY, HELPED_KEY } from '../const';
import { GAME_PAGE, GREEN, RED, BLUE, SKILL_PAGE, HELP_PAGE, START_PAGE } from '../../HOME/const';
import { goToPage } from '../../HOME/REDUX/actions';
import { selectSize, setOptions, setLevelsCompleted } from '../REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import Logo from '../ASSETS/TriominoLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { TT_GREEN, TT_RED, TT_PURPLE } from '../../TT/const';
import * as f from '../logic';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

class StartPage extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    dbget(OPTIONS_KEY, options => {
      this.props.setOptions(options);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleSize = size => {
    this.props.selectSize(size);

    dbget(HELPED_KEY, response => {
      if (!response && !this.props.helped) {
        this.props.setLevelsCompleted(0);
        this.props.goToPage(HELP_PAGE, START_PAGE);
        return;
      }

      dbget(f.boardKey(this.props), json => {
        if (json) {
          this.props.goToPage(GAME_PAGE);
          return;
        }

        dbget(f.levelsCompletedKey(this.props), level => {
          this.props.setLevelsCompleted(level > 0 ? level : 0);
          this.props.goToPage(level > 0 ? SKILL_PAGE : GAME_PAGE);
        });
      });
    });
  };

  render() {
    const { x, y } = windowSize();
    const width = Math.min(x, y) / 7;
    const style = { letterSpacing: '0.1em', zIndex: 1 };

    return (
      <div className="page-root">
        <div className="mt-logo-title">
          <img src={Logo} width={width} alt="Memory Twist logo" />
          <span className="mt-title" style={{ color: 'black', transform: 'translate(0.05em, 0.05em)', letterSpacing: '0.1em' }}>
            TRIOMINO
          </span>
          <span className="mt-title" style={{ color: GREEN, ...style }}>
            TRIOMINO
          </span>
          <span className="mt-title" style={{ color: RED, ...style }}>
            TRIOM
          </span>
          <span className="mt-title" style={{ color: BLUE, ...style }}>
            TRI
          </span>
        </div>
        <div className="tm-page" style={{ backgroundImage: Background }}>
          <div style={{ display: 'grid', grid: 'auto auto/auto auto' }}>
            <div className="tm-size-option" style={{ gridArea: '1/1', background: TT_GREEN }} onClick={() => this.handleSize(5)}>
              5×5
            </div>
            <div className="tm-size-option" style={{ gridArea: '1/2', background: TT_PURPLE }} onClick={() => this.handleSize(6)}>
              6×6
            </div>
            <div className="tm-size-option" style={{ gridArea: '2/1', background: TT_RED }} onClick={() => this.handleSize(7)}>
              7×7
            </div>
            <div className="tm-size-option tm-help-option" onClick={() => this.props.goToPage(HELP_PAGE)}>
              ?
            </div>
          </div>
        </div>
        <BmgButton />
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, setOptions, selectSize, setLevelsCompleted }
)(StartPage);
